export default function Divider({ gradient = false, className = '' }) {
  if (gradient) {
    return (
      <div
        className={`w-full h-[4px] bg-gradient-to-r from-sky-400 via-blue-500 to-sky-400 ${className}`}
      />
    );
  }

  return <div className={`w-full h-[1px] bg-slate-200 ${className}`} />;
}
